/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Link_CopiedInputs */



/**
* | output |
* | --- |
* | "Share link copied" |
*
* @param {Team_Share_Link_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_link_copied = /** @type {((inputs?: Team_Share_Link_CopiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Link_CopiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "de") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "it") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "es") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Share link copied")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Share link copied")
	return /** @type {LocalizedString} */ ("Share link copied")
});